module.exports = __webpack_public_path__ + "static/media/intro.ff69ba3f.mp3";